<template>
  <el-container>
    <!-- <el-aside>
      <el-container>
        <aside-table @active="active" :userinfo="userinfo"></aside-table>
      </el-container>
    </el-aside> -->
    <el-main class="main-m">
      <el-container>
        <el-header class="m-m-header">
          <!-- <el-input
            placeholder="请输入信息"
            v-model="queryPrams.keywords"
            class="m-m-h-margin-left"
          ></el-input>
          <el-select
            v-model="queryPrams.operationType"
            class="m-m-h-margin-left"
          >
            <el-option value="" label="全部"></el-option>
            <el-option value="0" label="其他"></el-option>
            <el-option value="1" label="增加"></el-option>
            <el-option value="2" label="修改"></el-option>
            <el-option value="3" label="删除"></el-option>
          </el-select> -->
          <el-date-picker
            class="m-m-h-margin-left"
            v-model="timer"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <el-button
            type="primary"
            @click="queryOperationlog(true)"
            class="m-m-h-margin-left"
            >查询</el-button
          >
        </el-header>
        <el-main>
          <el-table
            :data="queryList"
            border
            :header-cell-style="{ background: '#409EFF', color: '#fff' }"
          >
            <el-table-column
              prop="loginName"
              label="账号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="userName"
              label="登录名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="loginTime"
              label="时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="loginIp"
              label="登录IP"
              align="center"
            ></el-table-column>
          </el-table>
        </el-main>
        <el-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryPrams.start"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="queryPrams.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-footer>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
// import AsideTable from "@/components/modules/aside-table";
export default {
  //   components: { AsideTable },
  data() {
    return {
      total: 0,
      timer: "",
      queryList: [],
      queryPrams: {
        pageSize: 10,
        currentPage: 1,
        userId: "",
        startDate: "",
        endDate: ""
      }
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.queryOperationlog();
  },
  mounted() {},
  methods: {
    //小区点击
    // active(row) {
    //   this.queryPrams.unitId = row.userId;
    //   console.log("aa");

    //   this.queryOperationlog()
    // },
    //分页
    handleSizeChange(val) {
      this.queryPrams.pageSize = val;
      this.queryOperationlog();
    },
    handleCurrentChange(val) {
      this.queryPrams.currentPage = val;
      this.queryOperationlog();
    },
    /*
     **  @description 查询日志
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryOperationlog(val) {
      if (val) {
        this.queryPrams.currentPage = 1
      }
      this.queryPrams.userId = this.userinfo.uid;
      if (this.timer) {
        this.queryPrams.startDate = this.timer[0];
        this.queryPrams.endDate = this.timer[1];
      }else{
        this.queryPrams.startDate = '';
        this.queryPrams.endDate = '';
      }
      let url = "/dapi/u/listLoginLog";
      let params = { ...this.queryPrams };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          if (data.data != []) {
            this.total = data.rowCount;
            this.queryList = data.data;
          }
        } else {
          this.$message.error(data.message);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.el-container {
  height: 100%;
  .el-aside {
    box-shadow: @box-shadow;
  }
  .main-m {
    padding: 0;
    .m-m-header {
      display: flex;
      padding: 16px;
      box-shadow: @box-shadow;
      .el-date-picker{
        min-width: 400px;
      }
      .m-m-h-margin-left {
        margin-right: 20px;
      }
    }
  }
}
</style>
